import { render, staticRenderFns } from "./Reg3.vue?vue&type=template&id=77c4f4d2&scoped=true&"
import script from "./Reg3.vue?vue&type=script&lang=js&"
export * from "./Reg3.vue?vue&type=script&lang=js&"
import style0 from "./Reg3.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Reg3.vue?vue&type=style&index=1&id=77c4f4d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c4f4d2",
  null
  
)

export default component.exports